export type StickyPosition = 'none' | 'top' | 'bottom'

type StickyPositionStyle = {
    position?: 'sticky'
    height?: 'auto'
    top?: 0
    bottom?: 0
}

export function getStickyPositionStyle(stickyPosition?: StickyPosition): StickyPositionStyle {
    if (!stickyPosition || stickyPosition === 'none') {
        return {}
    }

    return {
        position: 'sticky',
        height: 'auto',
        top: stickyPosition === 'top' ? 0 : undefined,
        bottom: stickyPosition === 'bottom' ? 0 : undefined,
    }
}
